import { createContext } from 'react'

import { createRemoteTransferStore } from '../store/createStore'

export const RemoteTransferStoreContext = createContext<
  ReturnType<typeof createRemoteTransferStore> | undefined
>(undefined)
